import { FindAddressItem } from './types'

export const isAddress = (result: FindAddressItem) => result.type === 'Address'
